import { memo } from 'react';
import { type NodeProps } from 'reactflow';
import { FileCode } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

export const TemplateRendererNode = memo(({ data, selected }: NodeProps) => (
    <BaseNodeUI
        title={data?.label || 'Template Renderer'}
        icon={FileCode}
        colorClass="from-rose-500 to-rose-700"
        bgClass="bg-gradient-to-br from-rose-500 to-rose-700"
        selected={selected}
        isRunning={data?.executionStatus === 'Running'}
        executionStatus={data?.executionStatus}
        isSource={false}
        isTarget={true}
        rowsProcessed={data?.rowsAffected}
    />
));
TemplateRendererNode.displayName = 'TemplateRendererNode';
export default TemplateRendererNode;
